// const Index = resolve => require(['@/page/index'], resolve)
// const Zhuli = resolve => require(['@/page/zhuli'], resolve)
// const uid = resolve => require(['@/page/uid'], resolve)
const home = resolve => require(['@/page/home'], resolve)
const order = resolve => require(['@/page/order'], resolve)
const myorder = resolve => require(['@/page/myorder'], resolve)
const error = resolve => require(['@/page/error'], resolve)

const routes = [{
  path: '/fanxianka/',
  name: '订单高额返现',
  component: home
  },
  // {
  //   path: '/fanxianka/zhuli',
  //   name: '好友助力',
  //   component: Zhuli
  // },
  // {
  //   path: '/fanxianka/uid',
  //   name: '订单高额返现uid',
  //   component: uid
  // },
  {
    path: '/fanxianka/order',
    name: '提交订单',
    component: order
  },
  {
    path: '/fanxianka/myorder',
    name: '高额返现卡订单',
    component: myorder
  },
  {
    path: '/*',
    name: '404',
    component: error
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/route/index.js